import {post} from './';
export const login = (body) => {
  const url = '/login'
  return post(url, body)
}
